import {AdminsItemInfos} from "./AdminsItemInfos"

export class AdminsItemInfo{

	constructor()
	{
		this.adminCode = null;
		this.children = null;
		this.count = -1;
		this.name = null;
		this.parent = null;
	}
	

	/// <summary>
	/// 解析单个jsonitem
	/// </summary>
	/// <param name="jsonObj"></param>
	static GetAdminsItem(jsonObj){
		let curItem=null;
			if(jsonObj==null)return curItem;
			
			curItem=new AdminsItemInfo();
			curItem.adminCode=jsonObj.adminCode;
			curItem.name=jsonObj.name;
			
			return curItem;
	};

	/// <summary>
	/// 获得树状结构对象
	/// </summary>
	/// <param name="jsonObj">json对象</param>
	static GetTreeAdminsItem(jsonObj){
		let curItem=null;
			if(jsonObj==null)return curItem;
			
			curItem = AdminsItemInfo.GetAdminsItem(jsonObj);
			curItem.children=AdminsItemInfos.GetAdminsItems(jsonObj.childAdmins);
			if(curItem.children && curItem.children.objects)
			{	
				for(let tempIndex in curItem.children.objects) 
				{	
					curItem.children.objects[tempIndex].parent=curItem;
					// tempItem.parent = curItem;
				}
			}
			
			return curItem;

	};

}


